import * as React from "react";
import { useState, useEffect } from "react";
import { Button, KIND } from "baseui/button";
import { Input } from "baseui/input";
import { useStyletron, styled } from "baseui";
import { LabelLarge } from "baseui/typography";
import { MainContainer, InputContainer } from "./LoginStyles";
import { AuthForm, StyledLink } from "./AuthForm"; // Import AuthForm

function ResetPasswordView(props) {
  const [css, theme] = useStyletron();
  const [username, setUsername] = useState("");
  const [error, setError] = useState("");

  useEffect(() => {
    setError(props.error);
  }, [props.error, props.isLoading]);

  const validateUsername = (username) => {
    const regex = /^[A-Za-z0-9_]+$/; // regex for no spaces and no special characters
    return regex.test(username);
  };

  const handleSendResetRequest = () => {
    if (!validateUsername(username)) {
      setError("Username should not contain spaces or special characters.");
      return;
    }
    props.onSendResetRequest(username);
  };

  return (
    <AuthForm error={error} isLoading={props.isLoading}>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <LabelLarge
              className={css({ marginBottom: theme.sizing.scale300 })}
            >
              Reset Your Password
            </LabelLarge>
            <Input
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              placeholder="Enter your username"
              clearable
            />
          </div>
          <div className={css({ marginBottom: theme.sizing.scale600 })}>
            <Button
              kind={KIND.primary}
              isLoading={props.isLoading}
              onClick={handleSendResetRequest}
              overrides={{
                BaseButton: { style: { width: "100%" } },
              }}
            >
              Send
            </Button>
          </div>
          <div
            className={css({
              display: "flex", // Use flexbox to center the link
              justifyContent: "center", // Center horizontally
              alignItems: "center", // Center vertically
              marginBottom: theme.sizing.scale600,
            })}
          >
            <StyledLink onClick={props.onNavigate}>Back to Sign In</StyledLink>
          </div>
        </AuthForm>
  );

}
export default ResetPasswordView;
